export default {
    // Current user
    setCurrentUser (state, user) {
        state.current = user
    },

    // Online users
    populateOnlineUsers (state, users) {
        state.onlineUsers = users
    },

    addOnlineUser (state, userToAdd) {
        if (state.onlineUsers.some(user => user.id === userToAdd.id) === false) {
            state.onlineUsers.push(userToAdd)
        }
    },

    removeOnlineUser (state, userToRemove) {
        state.onlineUsers = state.onlineUsers.filter(user => user.id !== userToRemove.id)
    }
}
